// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a938265a","455":"98d6368f"}[chunkId] + ".chunk.js";
};